module.exports = __webpack_public_path__ + "img/people-tab1.a4d52ff5.png";